import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from 'emotion';
import { until, from } from '@guardian/src-foundations/mq';
export const Hide = ({ children, when, breakpoint, el, key, }) => {
    let whenToHide;
    if (when === 'below') {
        whenToHide = css `
			${until[breakpoint]} {
				display: none;
			}
		`;
    }
    else {
        whenToHide = css `
			${from[breakpoint]} {
				display: none;
			}
		`;
    }
    return el === 'li' ? (_jsx("li", Object.assign({ className: whenToHide }, { children: children }), key)) : (_jsx("span", Object.assign({ className: whenToHide }, { children: children }), void 0));
};
